import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397d9e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-icon up-ext" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "app-text",
  "data-testid": "display-name"
}
const _hoisted_4 = {
  class: "app-sub-text",
  "data-testid": "origin"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider mb-2" }, null, -1 /* HOISTED */))
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "app-text",
  "data-testid": "display-name"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "app-sub-text",
  "data-testid": "origin"
}

import { useRouter } from 'vue-router'
import makeBlockie from 'ethereum-blockies-base64'
import { computed, ref, watch } from 'vue'

import Permissions from '@/popup/components/shared/ControllerPermissions/Permissions.vue'
import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'
import DefaultIcon from '@/assets/compass-outline.png'
import UPIcon from '@/assets/up-icon.png'
import { truncateMiddle } from '@/shared/utils'
import { useUIStore } from '@/popup/store/UIStore'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import Picture from '@/popup/components/shared/Picture.vue'
import { t } from '@/popup/lib/i18n'
import { ControlLevel, ControllerDTO } from '@/business-logic/profile'
import { getControlLevelText } from '@/popup/utils/getControlLevelText'
import { useProfileStore } from '@/popup/store/ProfileStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ControllersPanel',
  setup(__props) {

const profileStore = useProfileStore()
const uiStore = useUIStore()
const router = useRouter()

const showControllers = computed(() => uiStore.currentTab === 'AUTHORIZED')

const controllers = ref<ControllerDTO[]>()
const isPending = ref(true)
watch(
  () => profileStore.controllers,
  async newControllers => {
    if (!newControllers) {
      isPending.value = true
      return
    }
    controllers.value = newControllers
    isPending.value = false
  },
  { immediate: true }
)

const deviceController = computed(() => profileStore.deviceController)

const controllersExceptDeviceController = computed(() => {
  return (
    controllers.value?.filter(
      app => app.address !== deviceController.value?.address
    ) ?? []
  )
})

const deviceControllerHasControl = computed(() => {
  return (
    deviceController.value?.permissions.controlLevel === ControlLevel.Partial ||
    deviceController.value?.permissions.controlLevel === ControlLevel.Full
  )
})

return (_ctx: any,_cache: any) => {
  return (controllers.value)
    ? _withDirectives((_openBlock(), _createBlock(Scroll, {
        key: 0,
        class: "p-4"
      }, {
        default: _withCtx(() => [
          _createVNode(Permissions, {
            disabled: !deviceControllerHasControl.value,
            "is-level0-enabled": 
        deviceController.value?.permissions.anyProfileDataAndSignEnabled
      ,
            "is-level1-enabled": 
        deviceController.value?.permissions.anyAccountInteractionsAndExtensionsEnabled
      ,
            "is-level2-enabled": 
        deviceController.value?.permissions.anyAdministrationAndOwnershipEnabled
      ,
            class: _normalizeClass(["wrapper mb-2 p-2", {
        'is-clickable': deviceControllerHasControl.value,
      }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
        deviceControllerHasControl.value
          ? _unref(router).push({
              name: 'controllerDetail',
              params: {
                controllerAddress: deviceController.value?.address,
              },
            })
          : undefined
      ))
          }, {
            icon: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(Picture, {
                  "picture-url": _unref(UPIcon),
                  size: 24,
                  "data-testid": "up-extension-icon"
                }, {
                  default: _withCtx(() => [
                    (deviceController.value?.address)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(makeBlockie)(deviceController.value?.address),
                          class: "up-identicon",
                          "data-testid": "identicon"
                        }, null, 8 /* PROPS */, _hoisted_2))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["picture-url"])
              ])
            ]),
            text: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(UserName, {
                    profile: {
                name:
                  deviceController.value?.customName ??
                  _unref(t)(
                    'profile.create.authorized_apps.browser_extension_display_name'
                  ),
                address: deviceController.value?.address,
              },
                    "max-width": 210,
                    "has-at-sign": false,
                    "has-slice-address": true
                  }, null, 8 /* PROPS */, ["profile"])
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(
                _unref(getControlLevelText)(
                  deviceController.value?.permissions.controlLevel ||
                    _unref(ControlLevel).None
                )
              )), 1 /* TEXT */)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "is-level0-enabled", "is-level1-enabled", "is-level2-enabled", "class"]),
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controllersExceptDeviceController.value, ({
        name,
        icon,
        address,
        permissions,
      }) => {
            return (_openBlock(), _createBlock(Permissions, {
              key: address,
              "is-level0-enabled": permissions.anyProfileDataAndSignEnabled,
              "is-level1-enabled": 
        permissions.anyAccountInteractionsAndExtensionsEnabled
      ,
              "is-level2-enabled": permissions.anyAdministrationAndOwnershipEnabled,
              class: "wrapper is-clickable mb-2 p-2",
              onClick: ($event: any) => (
        _unref(router).push({
          name: 'controllerDetail',
          params: { controllerAddress: address },
        })
      )
            }, {
              icon: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["app-icon", { 'remove-bg': !name }])
                }, [
                  (!name)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: icon || _unref(makeBlockie)(address),
                        class: "up-identicon bigger",
                        "data-testid": "identicon"
                      }, null, 8 /* PROPS */, _hoisted_6))
                    : (_openBlock(), _createBlock(Picture, {
                        key: 1,
                        "picture-url": icon || _unref(DefaultIcon),
                        size: 24,
                        "data-testid": "up-extension-icon"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(makeBlockie)(address),
                            class: "up-identicon",
                            "data-testid": "identicon"
                          }, null, 8 /* PROPS */, _hoisted_7)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["picture-url"]))
                ], 2 /* CLASS */)
              ]),
              text: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    (!name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(truncateMiddle)(address, 4)), 1 /* TEXT */))
                      : (_openBlock(), _createBlock(UserName, {
                          key: 1,
                          profile: {
                name,
                address,
              },
                          "max-width": 210,
                          "has-at-sign": false,
                          "has-slice-address": true
                        }, null, 8 /* PROPS */, ["profile"]))
                  ]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(
                _unref(getControlLevelText)(
                  permissions.controlLevel || _unref(ControlLevel).None
                )
              )), 1 /* TEXT */)
                ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-level0-enabled", "is-level1-enabled", "is-level2-enabled", "onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 512 /* NEED_PATCH */)), [
        [_vShow, showControllers.value]
      ])
    : _createCommentVNode("v-if", true)
}
}

})